import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Home, 
  Image, 
  Users, 
  Settings, 
  FileText, 
  Mail, 
  Phone,
  MapPin,
  Globe,
  Menu,
  X,
  Wrench,
  PlayCircle,
  UserCheck,
  BookOpen,
  MessageSquare,
  DollarSign,
  Layers
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import {
  SidebarContainer,
  SidebarHeader,
  Logo,
  ToggleButton,
  Navigation,
  NavItem,
  NavLinkStyled,
  NavIcon,
  NavText,
  SidebarOverlay
} from './Sidebar.styles';

const Sidebar = ({ isOpen, onToggle }) => {
  const navigationItems = [
    {
      path: '/dashboard',
      icon: Home,
      label: 'Dashboard',
      exact: true
    },
    {
      path: '/hero-section',
      icon: Image,
      label: 'Hero Section'
    },
    {
      path: '/about-section',
      icon: FileText,
      label: 'About Section'
    },
    {
      path: '/services-section',
      icon: Wrench,
      label: 'Services Section'
    },
    {
      path: '/how-it-works-section',
      icon: PlayCircle,
      label: 'How It Works Section'
    },
    {
      path: '/our-team-section',
      icon: UserCheck,
      label: 'Our Team Section'
    },
    {
      path: '/blogs-section',
      icon: BookOpen,
      label: 'Blogs Section'
    },
    {
      path: '/testimonials-section',
      icon: MessageSquare,
      label: 'Testimonials Section'
    },
    {
      path: '/pricing-section',
      icon: DollarSign,
      label: 'Pricing Section'
    },
    {
      path: '/services-page',
      icon: Layers,
      label: 'Services Page'
    },
    {
      path: '/contact-section',
      icon: Mail,
      label: 'Contact Section'
    },
    {
      path: '/users',
      icon: Users,
      label: 'Users'
    },
    {
      path: '/settings',
      icon: Settings,
      label: 'Settings'
    }
  ];

  return (
    <>
      <SidebarContainer isOpen={isOpen}>
        <SidebarHeader>
          <Logo>CMS</Logo>
          <ToggleButton onClick={onToggle}>
            <X size={20} />
          </ToggleButton>
        </SidebarHeader>

        <Navigation>
          {navigationItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <NavItem key={item.path}>
                <NavLinkStyled
                  to={item.path}
                  end={item.exact}
                  onClick={() => {
                    // Close sidebar on mobile/tablet after navigation, keep open on desktop
                    if (window.innerWidth <= 1024) {
                      onToggle();
                    }
                  }}
                >
                  <NavIcon>
                    <IconComponent size={20} />
                  </NavIcon>
                  <NavText>{item.label}</NavText>
                </NavLinkStyled>
              </NavItem>
            );
          })}
        </Navigation>
      </SidebarContainer>

      {isOpen && <SidebarOverlay onClick={onToggle} />}
    </>
  );
};

export default Sidebar;
